<template>
    <v-app>
        <header-card-public ref="refHeader" current_page="sign-up"></header-card-public>
        
        <v-content class="content-container">
            <v-layout fill-height align-center row wrap>
                <v-flex xs12 sm12 :class="isMobile?'form-container-mobile':'form-container'">
                    <v-form @submit.prevent="executeRecaptcha" ref="form">
                        <v-card dense style="border-radius:4px;">
                            <v-toolbar flat height="45px">
                                <span class="font-weight-bold subheading">Book Your Free Demo with SweldoNow</span>
                                <v-spacer></v-spacer>
                                <span v-if="partnerData&&!isMobile" style="color:#1976D2;">Referred by Business Development Partner: <b>{{ partnerData.firstName }} {{ partnerData.lastName }}</b></span>
                            </v-toolbar>
                            <v-alert v-if="error" :value="true" color="error" icon="error" outline class="header-intro">
                                {{ errorMessage }}
                            </v-alert>
                            <v-card-text dense>
                                <v-layout row wrap v-if="partnerData&&isMobile">
                                    <v-flex xs12 sm12 style="margin-left:25px;color:#1976D2">
                                        <p>Referred by Business Development Partner: <b>{{ partnerData.firstName }} {{ partnerData.lastName }}</b></p>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12>
                                        <p v-html="intro.line1" class="header-intro subheading"></p> 
                                        <p v-html="intro.line2" class="header-intro"></p>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm8 :class="isMobile?'content-mobile':'content1'">
                                        <v-text-field label="Company name"
                                            prepend-inner-icon="store"
                                            v-model="company"
                                            :rules="[rules.required]"
                                            :disabled="disabled"
                                            maxlength="100"
                                            @keyup="error=false"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4 :class="isMobile?'content-mobile':'content2'">
                                        <v-text-field label="Email"
                                            prepend-inner-icon="email"
                                            v-model="email"
                                            :rules="[rules.required, rules.email]"
                                            :disabled="disabled"
                                            maxlength="100"
                                            hint="Login details will be sent to this email."
                                            @keyup="error=false"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 :class="isMobile?'content-mobile':'content1'">
                                        <v-text-field label="First Name"
                                            prepend-inner-icon="person"
                                            v-model="firstName"
                                            :rules="[rules.required]"
                                            :disabled="disabled"
                                            maxlength="100"
                                            @keyup="error=false"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4 :class="isMobile?'content-mobile':'content1'">
                                        <v-text-field label="Last Name"
                                            prepend-inner-icon="person"
                                            v-model="lastName"
                                            :rules="[rules.required]"
                                            :disabled="disabled"
                                            maxlength="100"
                                            @keyup="error=false"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4 :class="isMobile?'content-mobile':'content2'">
                                        <v-text-field label="Position"
                                            prepend-inner-icon="badge"
                                            v-model="position"
                                            :rules="[rules.required]"
                                            :disabled="disabled"
                                            maxlength="50"
                                            @keyup="error=false"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm8 :class="isMobile?'content-mobile':'content1'">
                                        <v-select
                                            prepend-inner-icon="domain"
                                            label="Industry"
                                            :items="industry_list"
                                            :rules="[rules.required]" 
                                            item-text="name"
                                            item-value="id"
                                            :disabled="disabled"
                                            v-model="industryId"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm4 :class="isMobile?'content-mobile':'content2'">
                                        <v-text-field label="Employees"
                                            prepend-inner-icon="groups"
                                            v-model="employeesCount"
                                            :rules="[rules.required_number]"
                                            :disabled="disabled"
                                            type="number"
                                            hint="Estimated number of employees in your company."
                                            @keyup="error=false"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap style="margin-top:10px;" v-if="isMobile">
                                    <v-flex xs12 sm12 class="content-mobile">
                                        <sign-up-privacy-link />
                                    </v-flex>
                                </v-layout>
                            </v-card-text>  
                            <v-divider></v-divider>
                            <v-card-actions v-if="!isMobile" style="margin-left:20px;">
                                <sign-up-privacy-link />
                                <v-spacer></v-spacer>
                                <v-btn color="#1976D2" type="submit" large :loading="loading" dark style="margin:5px 30px 5px 0px;">Book Demo</v-btn>
                            </v-card-actions>
                            <v-card-actions v-if="isMobile">
                                <v-btn color="#1976D2" type="submit" block large :loading="loading" dark style="margin:10px 20px 10px 20px;">Book Demo</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-flex>
            </v-layout>
        </v-content>

        <!-- FOOTER -->
        <v-footer dark height="auto">
            <footer-card></footer-card>
        </v-footer>
        
        <v-dialog v-model="dialogConfirmation" width="600" persistent>   
            <sign-up-confirm ref="signUpConfirmationRef" :dialogConfirmation.sync="dialogConfirmation" @send="goToHome"></sign-up-confirm>
        </v-dialog>

        <recaptcha ref="recaptcha" @verify="submitReCaptcha"></recaptcha>
    </v-app>
</template>
<script>

import registrationApi from '@/api/registration'
import '@/assets/css/public-FaceAI.css' 
import UAParser from "ua-parser-js"

export default {
    name: 'SignUp',
    metaInfo: {
        title: 'Sign Up',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: '' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'sign-up-confirm': () => import('@/components/BookForDemoConfirmation'),
        'recaptcha': () => import('@/components/ReCaptcha.vue'),
        'header-card-public': () => import('@/components/HeaderPublic'),
        'footer-card': () => import('@/components/Footer'),
        'sign-up-privacy-link': () => import('@/components/SignUpPrivacyLink')
    },
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            rules: {
                required: value => !!value || 'Required.',
                required_number: value => !!value || 'Required. Number only.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                },
                cellphone: value => {
                    const pattern = /\d{4}\d{3}\d{4}/
                    return pattern.test(value) || 'Invalid Cellphone no.'
                },
            },
            //static data for faster rendering, this list also exist in dbo.Industries
            industry_list: [
                { id: 1, name: 'Agriculture' },
                { id: 2, name: 'Architecture and Engineering' },
                { id: 3, name: 'Construction' },
                { id: 4, name: 'Education and Training' },
                { id: 5, name: 'E-Commerce' },
                { id: 6, name: 'Energy and Utilities' },
                { id: 7, name: 'Healthcare and Medical Services' },
                { id: 8, name: 'Hospitality (Hotels, Restaurants, Cafes)' },
                { id: 9, name: 'IT, BPO, and Business Services' },
                { id: 10, name: 'Logistics, Transport, and Warehousing' },
                { id: 11, name: 'Manufacturing' },
                { id: 12, name: 'Professional Services (Legal, Accounting, Consulting)' },
                { id: 13, name: 'Real Estate and Property Management' },
                { id: 14, name: 'Retail and Wholesale' },
                { id: 15, name: 'Tourism and Travel' },
                { id: 16, name: 'Non-Profit / NGO' },
                { id: 17, name: 'Other / Not Listed' }
            ],
            intro: {
                line1: `Discover how SweldoNow helps cut payroll costs and automate your entire payroll process. Just fill out the form below and click <b>Book Demo</b> button. Our team will contact you within 1 business day to schedule your session.`,
                line2: ``
            },
            //static data for faster rendering
            sales_partners: [
                {
                    partnerId: "ej",
                    userId: "us0000082o9tssmq40eel",
                    firstName: "Ezra Jeremy",
                    lastName: "Rosero"
                },
                {
                    partnerId: "ashley",
                    userId: "us0000083mgj4wwpbtdbh",
                    firstName: "Joanne Ashley",
                    lastName: "Antonio"
                },
                {
                    partnerId: "jana",
                    userId: "us0000080ujb8hvwtqefz",
                    firstName: "Jana",
                    lastName: "Serrano"
                },
                {
                    partnerId: "kc",
                    userId: "us0000083jfathro7htp3",
                    firstName: "Kearsy",
                    lastName: "Rosete"
                }
            ],
            dialogConfirmation: false,
            isNoInternet: false,
            email: null,
            company: null,
            address: null,
            industry: null,
            industryId: null,
            firstName: null,
            lastName: null,
            position: null,
            cellphone: null,
            employeesCount: null,
            ua_parser: null,
            ua_data: null,
            partnerData: null
         }
    },
    methods: {
        goToHome() {
            this.dialogConfirmation = false
            this.$router.push('/')
        },
        async submitReCaptcha(gresponse) {
            await this.bookNow(gresponse)
        },
        executeRecaptcha() {
            this.error = false
            if (this.$refs.form.validate()) {
                this.loading = true
                this.disabled = true
                this.$refs.recaptcha.execute()
            }
        },
        async bookNow(gresponse) {
            try {
                this.loading = true
                const data = {
                    recaptchaResponse: gresponse,
                    company: this.company,
                    industry: this.industry_list.filter(x => x.id == this.industryId)[0].name,
                    industryId: this.industryId,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    position: this.position,
                    email: this.email,
                    employeesCount: this.employeesCount,
                    browserName: this.ua_data.browser.name,
                    deviceModel: this.ua_data.device.model,
                    deviceType: this.ua_data.device.type,
                    deviceVendor: this.ua_data.device.vendor,
                    oSName: this.ua_data.os.name,
                    oSVersion: this.ua_data.os.version,
                    partnerUserId: this.partnerData ? this.partnerData.userId : null
                }
                const response = await registrationApi.bookDemo(data)
                if (response && response.status==200) {
                    gtag_report_conversion() //google conversion tracker
                    this.dialogConfirmation = true
                }
                this.loading = false
                this.disabled = false
            }catch(error) {
                if (error.toString().includes("409")) {
                    this.errorMessage = `Email ${this.email} already exist in our database.`
                }            
                else if (error.toString().includes("401") || error.toString().includes("500")) {
                    this.errorMessage = `Error encountered while processing request. If issue persist, contact support@sweldonow.ph`
                }
                else {
                    this.errorMessage = error
                }
                this.error = true
                this.loading = false
                this.disabled = false
            }
        },
        getPartnerId() {
            // 1. Normalize all query keys to lowercase
            const query = Object.keys(this.$route.query).reduce((acc, key) => {
                acc[key.toLowerCase()] = this.$route.query[key]
                return acc
            }, {})

            // 2. Extract partnerid from query (case-insensitive), convert value to lowercase
            let partnerId = query.partnerid ? query.partnerid.toLowerCase() : null

            // 3. If found in URL, save to localStorage with expiry (30 days)
            if (partnerId) {
                localStorage.setItem("partnerId", partnerId)
                localStorage.setItem(
                "partnerIdExpiry",
                Date.now() + 30 * 24 * 60 * 60 * 1000 // 30 days
                )
                return partnerId
            }

            // 4. If not in URL, check localStorage
            const storedPartnerId = localStorage.getItem("partnerId")
            const expiry = localStorage.getItem("partnerIdExpiry")

            if (storedPartnerId && expiry && Date.now() < expiry) {
                return storedPartnerId.toLowerCase()
            }

            // 5. If expired or missing, clean up
            localStorage.removeItem("partnerId")
            localStorage.removeItem("partnerIdExpiry")
            return null
        }
    },
    created() {
        this.ua_parser = new UAParser(navigator.userAgent)
        this.ua_data = this.ua_parser.getResult()
    },
    mounted() {
        const partnerId = this.getPartnerId()
        if (partnerId) {
            const partnerData = this.sales_partners.filter(x => x.partnerId == partnerId)
            if (partnerData.length) this.partnerData = partnerData[0]
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
    },
}
</script>
<style scoped>
.content-container {
    background: 
        linear-gradient(to right, rgb(0, 7, 8, 0.7), rgba(13, 13, 14, 0.1)), 
        url("../assets/landing/landing1.webp");
    height:auto;
    min-height:600px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    font-family:Roboto;
}
.form-container {
    margin: 80px 100px 50px 100px;
}
.form-container-mobile {
    margin: 110px 20px 50px 20px;
}
.content1 {
    padding: 0px 20px 0px 20px;
}
.content2 {
    padding: 0px 25px 0px 15px;
}
.content-mobile {
    padding: 0px 25px 0px 20px;
}
.header-intro {
    margin:5px 15px 15px 25px;
}
</style>